<template>
	<div class="home" v-title="pageTitle">
		<div class="contonts">
			<van-form>
			<van-field v-model="username" name="用户名" label="用户名" placeholder="用户名"
				:rules="[{ required: true, message: '请填写用户名' }]" />
			<van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码"
				:rules="[{ required: true, message: '请填写密码' }]" />
			
			<van-field v-model="sms" style="height: 50px;" center clearable label="验证码" placeholder="请输入验证码">
				<template #button >
					<img class="imgbase64" :src="src" @click.stop="loadkaptcha()" />
				</template>
			</van-field>

			<div style="margin: 16px;margin-top: 50px;">
				<van-button round block type="info" native-type="submit" @click.stop="updata">登 陆</van-button>
			</div>
		</van-form>
		</div>
	</div>
</template>

<script>
import request from '../api/request'
export default {
	name: 'home',
	data() {
		return {
			username: '',
			password: '',
			sms:'',
			src:'',
			pageTitle:'管理平台'
		}
	},
	components: {},
	activated() {
		if(localStorage.getItem('user')!=undefined){
			this.username=JSON.parse(localStorage.getItem('user')).username
		    this.password=JSON.parse(localStorage.getItem('user')).password
		}
		// console.log(localStorage.getItem('ulogin'))
		if(localStorage.getItem('ulogin')!=undefined){
		    window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04ae3e2831a1a047&redirect_uri=https%3A%2F%2Fmp.ytjdv.com&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect"
			console.log('重新加载了路由！')
            localStorage.removeItem('ulogin')
        }
		
		let geturl = window.location.href
		console.log(geturl)
		if(geturl.indexOf('code')!=-1){
			if (this.code == '') {
				this.$dialog.alert({
					message: '获取code失败！',
				}).then(() => {
					 window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04ae3e2831a1a047&redirect_uri=https%3A%2F%2Fmp.ytjdv.com&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect"
				})
			}else{
				this.code = geturl.split("code=")[1].split("&")[0]
			}
		}
		this.loadkaptcha()
	},
	methods: {
		updata() {
            if(this.username==''||this.password==''||this.sms=='') return
			const params={
				username:this.username,
				password:this.password,
				kaptcha:this.sms,
				code:this.code
			}
			console.log(params)
			request.getcommerlist(params, '/admin/auth/login', 'post', '', res => {
                console.log(res)
				if(res.errno==0){
					// that.src=res.data
					this.$toast('登陆成功！')
					localStorage.setItem('user', JSON.stringify({ username: this.username, password: this.password }))
					// localStorage.setItem('usermsg', JSON.stringify(res.data.adminInfo))
					// localStorage.setItem('token_yr', JSON.stringify(res.data.token))
                     request.setItem('usermsg',res.data.adminInfo)
                     request.setItem('token_yr',res.data.token)
					 request.setItem('openId_yr',res.data.openId.replace('"', "").replace('"', ""))
					this.$router.replace({ path: '/home', query: {} })
				}else{
					this.$toast(res.errmsg)
					// this.loadkaptcha()
					if(res.errno==606){
						this.src=res.data
					}
				}
				// localStorage.setItem('user', JSON.stringify({ username: this.username, password: this.password }))
				// this.$router.push({ path: '/mian', query: {} })
			})
			
		},
		loadkaptcha(){
			let that=this
			request.getcommerlist('','/admin/auth/kaptcha','get','',res=>{
				if(res.errno==0){
					that.src=res.data
					console.log(res)
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.home {
	// .fs;
	height: 100%;
	// background-color: #fff;
	background: linear-gradient(#78d4f6, #b8bdf7); //从上到下

	.contonts {
		padding: 40px;
		padding-top: 200px;
		border-radius: 10px;
		.imgbase64{width: 80px; height: auto;margin-top: 60px;}
	}

	img {
		width: 160px;
		height: 160px;
		margin: 100px 0 50px 0;
	}
}
</style>